import { Box, styled } from '@mui/material';

export const StyledResourcesSelectBox = styled(Box)`
    padding: 16px 16px 16px 16px;
`;
export const StyledTerminalSelectBox = styled(Box)`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
`;
export const StyledOtherSelectBox = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;
export const StyledArrivalResourcesBox = styled(Box)<{ isarrivalonly?: string }>`
    width: 100%;
    ${({ isarrivalonly }) =>
        isarrivalonly === 'false' ? 'border-right: 1px solid #b6d2e5; padding-right: 15px;' : ''};
`;
export const StyledDepartureResourcesBox = styled(Box)<{ isdepartureonly?: string }>`
    width: 100%;
    ${({ isdepartureonly }) => (isdepartureonly === 'false' ? 'padding-left: 15px;' : '')};
`;
export const selectSx = {
    minHeight: '75px',
    '.MuiInputLabel-root': {
        color: 'black',
    },
    '.MuiInputLabel-root.Mui-focused': {
        color: 'black',
    },
    '.MuiInputBase-root': {
        color: 'black',
        height: '35px',
    },
};
